import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmail from './pages/ConfirmEmail';
import AnnouncementBanner from './components/AnnouncementBanner';
// El test y el procesador (rack, efectos, codificadores…) son lo pesado: se
// bajan al entrar a su ruta, no con el login. En datos móviles se nota.
const loadTest = () => import('./pages/AudioTest');
const loadPlayer = () => import('./pages/MusicPlayer');
const AudioTest = lazy(loadTest);
const MusicPlayer = lazy(loadPlayer);
// Solo lo abren los admins: no se precarga, que el resto no lo baje nunca.
const AdminPanel = lazy(() => import('./pages/AdminPanel'));
const Cargando = () => <div style={{ minHeight: '100vh', background: 'rgb(var(--c-0a0405))' }} />;

function App() {
  // Con la primera pantalla ya pintada y el navegador libre, se van bajando en
  // segundo plano: al pulsar "Entrar" ya están y no hay espera.
  useEffect(() => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
    idle(() => { loadPlayer(); loadTest(); });
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<Cargando />}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* Los dos pasos de recuperar la contrasena. /reset-password recibe el
            token en la direccion (?token=...), que es como llega desde el correo. */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Enlace del correo nuevo (Mi perfil → Correo), con ?token=... */}
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/test" element={<AudioTest />} />
        <Route path="/music" element={<MusicPlayer />} />
        {/* Panel de control. La página echa a quien no sea admin, y el backend
            responde 403 a todo /admin igualmente. */}
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
      </Suspense>
      {/* Aviso del admin (mantenimiento, novedades) en todas las páginas. */}
      <AnnouncementBanner />
    </BrowserRouter>
  );
}

export default App;